import {
  Paragraph,
  PrimaryButtonCss,
  SecondaryButtonCss,
  h4,
} from "@/styles/typography";
import styled from "styled-components";

const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.coreDark};
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  padding: 24px;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    max-width: 676px;
    padding: 40px;
  }
`;

const H4 = styled(h4)``;

const Text = styled(Paragraph)``;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: row;
    gap: 24px;
  }
`;

const BackButton = styled.button`
  ${PrimaryButtonCss}
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: fit-content;
  }
`;

const StartButton = styled.button`
  ${SecondaryButtonCss}
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: fit-content;
  }
`;

const S = {
  Container,
  H4,
  Text,
  ButtonWrapper,
  BackButton,
  StartButton,
};

export default S;
